// Business-level schema functions
// These functions generate schemas that span multiple products/business entities

import { getAllProducts } from "../products";

/**
 * Generate makesOffer array for OnlineBusiness schema
 * Includes all products with both free and pro offers
 */
export function generateMakesOfferForBusiness() {
  const offers = [];

  for (const product of getAllProducts()) {
    // Free offer
    offers.push({
      "@type": "Offer",
      price: product.freeOffer.price,
      priceCurrency: product.freeOffer.priceCurrency,
      availability: "https://schema.org/InStock",
      name: `${product.alternateName} Free`,
      description: product.freeOffer.description,
      itemOffered: {
        "@type": "SoftwareApplication",
        "@id": `${product.url}#software`,
        name: product.alternateName,
        applicationCategory: "BrowserExtension",
        operatingSystem: product.operatingSystem,
        downloadUrl: product.freeOffer.url,
        // Removed aggregateRating to prevent duplicate Review schema errors
        // Individual product pages have their own aggregateRatings
      },
    });

    // Pro offers (Monthly, Yearly, Lifetime)
    if (product.offers) {
      Object.values(product.offers).forEach((offer) => {
        offers.push({
          "@type": "Offer",
          price: offer.price,
          priceCurrency: offer.priceCurrency,
          availability: "https://schema.org/InStock",
          name: `${product.alternateName} ${offer.name}`,
          description: offer.description,
          ...(offer.priceValidUntil && {
            priceValidUntil: offer.priceValidUntil,
          }),
          url: offer.url,
          itemOffered: {
            "@id": `${product.url}#software`,
          },
        });
      });
    }
  }

  return offers;
}
